<section class="lead-gestor" aria-label="Lead atendido pela Mia Gestor" [attr.aria-busy]="carregando">
  <div class="esqueleto" *ngIf="!dados && carregando" aria-hidden="true">
    <div class="cabeca"><span class="avatar avatar--vazio"></span><div><i class="barra barra--larga"></i><i class="barra"></i></div></div>
    <i class="bloco"></i>
  </div>

  <ng-container *ngIf="!dados && !carregando && erro">
    <p class="faixa faixa--erro" role="alert">{{ erro }}</p>
    <button type="button" class="largo" (click)="carregue()"><i class="fas fa-sync-alt" aria-hidden="true"></i>Tentar de novo</button>
  </ng-container>

  <ng-container *ngIf="dados?.gestor">
    <header class="cabeca">
      <span class="avatar" aria-hidden="true">{{ inicial }}</span>
      <div class="identidade">
        <h3>{{ dados.lead?.nome || nome || 'Lead' }}</h3>
        <span class="empresa" *ngIf="dados.lead?.empresa" title="Empresa do lead"><i class="fas fa-store" aria-hidden="true"></i>{{ dados.lead.empresa }}</span>
        <span class="num">{{ telefoneFormatado }}</span>
      </div>
      <button type="button" class="icone-botao" (click)="carregue()" [disabled]="carregando" title="Atualizar" aria-label="Atualizar">
        <i class="fas fa-sync-alt" [class.girando]="carregando" aria-hidden="true"></i>
      </button>
    </header>

    <p class="canal">
      <i class="fas fa-robot" aria-hidden="true"></i>
      <span>Mia Gestor no {{ formateTelefone(dados.numero?.telefone) }}</span>
      <span class="pilula" *ngIf="dados.numero?.modoTeste" title="Só telefones da lista de teste são atendidos">Modo teste</span>
    </p>

    <div class="situacao situacao--{{ situacao.tom }}" role="status">
      <div class="situacao__linha">
        <span class="situacao__icone" aria-hidden="true"><i class="fas" [ngClass]="situacao.icone"></i></span>
        <div>
          <strong>{{ situacao.titulo }}</strong>
          <p>{{ situacao.texto }}</p>
        </div>
      </div>
      <ng-container *ngIf="leadPerdido">
        <button type="button" class="largo" (click)="reabra()" [disabled]="movendo">
          <i class="fas" [ngClass]="movendo ? 'fa-spinner fa-spin' : 'fa-undo-alt'" aria-hidden="true"></i>{{ movendo ? 'Reabrindo…' : 'Reabrir o lead' }}
        </button>
        <small class="nota">Volta para {{ rotuloEtapa(dados.lead?.etapaMinima || 'CONVERSA') }} e a Mia responde de novo a partir da próxima mensagem.</small>
      </ng-container>
      <ng-container *ngIf="podeChamar || podeAutorizar">
        <button type="button" class="primario largo" *ngIf="podeChamar" (click)="chameMia()" [disabled]="chamando || autorizando">
          <i class="fas" [ngClass]="chamando ? 'fa-spinner fa-spin' : 'fa-robot'" aria-hidden="true"></i>{{ chamando ? 'Chamando…' : (leadCalado ? 'Chamar a atenção do lead' : miaJaFalou ? 'Retomar a conversa' : 'Chamar a Mia para a conversa') }}
        </button>
        <button type="button" class="largo" *ngIf="podeAutorizar" (click)="autorize()" [disabled]="autorizando || chamando">
          <i class="fas" [ngClass]="autorizando ? 'fa-spinner fa-spin' : 'fa-user-check'" aria-hidden="true"></i>{{ autorizando ? 'Autorizando…' : 'Só autorizar' }}
        </button>
        <p class="acompanhamento acompanhamento--{{ acompanhamento.tom }}" role="status" *ngIf="acompanhamento as acompanhamento">
          <i class="fas" [ngClass]="acompanhamento.tom === 'andamento' ? 'fa-spinner fa-spin' : acompanhamento.tom === 'ok' ? 'fa-check-circle' : 'fa-exclamation-circle'" aria-hidden="true"></i>{{ acompanhamento.texto }}
        </p>
        <small class="nota" *ngIf="podeChamar && !miaJaFalou">Chamar: a Mia manda a primeira mensagem agora, continuando de onde a conversa parou.<ng-container *ngIf="podeAutorizar"> Só autorizar: ela responde a partir da próxima mensagem do lead.</ng-container></small>
        <small class="nota" *ngIf="miaJaFalou && !leadCalado">A Mia já falou e o lead ainda não respondeu. Retomar: ela lê o que mandou e ficou sem resposta e manda uma mensagem curta com algo novo, sem repetir o pedido nem recomeçar.</small>
        <small class="nota" *ngIf="leadCalado">A Mia lê o que mandou e ficou sem resposta e manda uma mensagem curta e leve com algo novo para ele responder. Sem repetir o pedido nem recomeçar.</small>
      </ng-container>
      <ng-container *ngIf="podeIniciarTeste">
        <button type="button" class="largo" (click)="inicieTeste()" [disabled]="iniciandoTeste || chamando || orientando || autorizando">
          <i class="fas" [ngClass]="iniciandoTeste ? 'fa-spinner fa-spin' : 'fa-store'" aria-hidden="true"></i>{{ iniciandoTeste ? 'Iniciando…' : 'Iniciar criação da loja' }}
        </button>
        <small class="nota">Pula a qualificação: a Mia avisa que vai montar a loja agora e pede só o que falta para o teste de 7 dias.</small>
      </ng-container>
    </div>

    <section class="compor" *ngIf="podeCompor" aria-labelledby="compor-titulo" [class.compor--arrastando]="arrastando"
             (dragover)="arraste($event, true)" (dragleave)="arraste($event, false)" (drop)="solteImagens($event)">
      <header class="compor__topo">
        <span class="compor__icone" aria-hidden="true"><i class="fas fa-pen-fancy"></i></span>
        <div>
          <h4 id="compor-titulo">Pedir uma mensagem à Mia</h4>
          <p>Diga o que você quer; ela escreve e você revisa antes de sair.</p>
        </div>
      </header>
      <div class="lead-disse" *ngIf="ultimasDoLead.length" role="region" aria-label="Mensagens do lead sem resposta" aria-live="polite">
        <div class="lead-disse__topo">
          <span class="lead-disse__titulo"><i class="fas fa-comment" aria-hidden="true"></i>O lead disse · sem resposta</span>
          <button type="button" class="lead-disse__copiar" (click)="copieMensagens()" title="Copia as mensagens abaixo, uma por linha">
            <i class="fas" [ngClass]="copiadoMensagens ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>{{ copiadoMensagens ? 'Copiado' : 'Copiar mensagens' }}
          </button>
        </div>
        <ul class="lead-disse__lista">
          <li *ngFor="let m of ultimasDoLead"><span>{{ m.texto }}</span><time *ngIf="hora(m.em)">{{ hora(m.em) }}</time></li>
        </ul>
        <small class="nota nota--atencao" *ngIf="novasDepoisDaPrevia">
          <i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ novasDepoisDaPrevia === 1 ? 'Chegou 1 mensagem' : 'Chegaram ' + novasDepoisDaPrevia + ' mensagens' }} depois desta prévia. Monte de novo para a Mia considerar.
        </small>
      </div>
      <div class="sugestoes" *ngIf="atalhosDeOrientacao.length" role="group" aria-label="Sugestões prontas">
        <span class="sugestoes__rotulo">Sugestões</span>
        <button type="button" class="sugestao" *ngFor="let a of atalhosDeOrientacao" (click)="useAtalho(a.texto)" [disabled]="orientando || chamando"
                [title]="a.texto" [class.sugestao--ativa]="orientacao === a.texto">{{ a.rotulo }}</button>
      </div>
      <div class="caixa" [class.caixa--desligada]="orientando || enviando || chamando">
        <label for="orientacao-mia" class="oculto">Como você quer a mensagem</label>
        <textarea id="orientacao-mia" rows="3" [(ngModel)]="orientacao" [disabled]="orientando || enviando || chamando" (paste)="coleImagem($event)"
                  placeholder="Como você quer a mensagem? Ex.: não abaixa o preço e oferece o teste de 7 dias de novo"></textarea>
        <ul class="anexos" *ngIf="imagens.length" aria-label="Imagens para a Mia ler">
          <li *ngFor="let img of imagens; let i = index">
            <img [src]="img" [alt]="'Imagem ' + (i + 1) + ' para a Mia ler'">
            <button type="button" class="anexos__remover" (click)="removaImagem(i)" [disabled]="orientando" [attr.aria-label]="'Remover imagem ' + (i + 1)" title="Remover">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </li>
        </ul>
        <div class="caixa__barra">
          <button type="button" class="anexar" (click)="seletorDeImagem.click()" [disabled]="imagens.length >= maxImagens || orientando || enviando || chamando"
                  title="Anexe um print para a Mia ler (também dá para colar com Ctrl+V ou arrastar)">
            <i class="fas fa-image" aria-hidden="true"></i>{{ imagens.length ? imagens.length + '/' + maxImagens : 'Imagem' }}
          </button>
          <input #seletorDeImagem type="file" class="oculto" accept="image/png,image/jpeg,image/webp" multiple (change)="escolhaImagens($event)" tabindex="-1" aria-hidden="true">
          <button type="button" class="primario" *ngIf="!rascunho" (click)="monteRascunho()" [disabled]="orientando || chamando || autorizando">
            <i class="fas" [ngClass]="orientando ? 'fa-spinner fa-spin' : 'fa-magic'" aria-hidden="true"></i>{{ orientando ? 'Montando…' : 'Montar mensagem' }}
          </button>
        </div>
        <div class="caixa__soltar" *ngIf="arrastando" aria-hidden="true"><i class="fas fa-image"></i>Solte a imagem aqui</div>
      </div>
      <small class="nota nota--erro" *ngIf="erroOrientacao">{{ erroOrientacao }}</small>
      <small class="compor__dica" *ngIf="orientando">A Mia está lendo a conversa<ng-container *ngIf="imagens.length"> e as imagens</ng-container>. Leva até um minuto.</small>
      <small class="compor__dica" *ngIf="!rascunho && !orientando && !erroOrientacao">Pode colar ou arrastar um print: a Mia lê como contexto, o lead não vê. Nada sai sem você.</small>
      <div class="rascunho" *ngIf="rascunho">
        <label for="rascunho-mia"><i class="fas fa-robot" aria-hidden="true"></i>Prévia da Mia · edite se quiser</label>
        <textarea id="rascunho-mia" rows="6" [(ngModel)]="rascunho.texto" [disabled]="enviando || orientando"></textarea>
        <div class="rascunho__botoes" *ngIf="rascunho.botoes?.length">
          <span class="rascunho__botao" *ngFor="let b of rascunho.botoes">{{ b.titulo }}</span>
        </div>
        <div class="rascunho__acoes">
          <button type="button" [class.primario]="!podeEnviarPelaMia" (click)="copieRascunho()" [disabled]="enviando || orientando || !rascunho.texto.trim()">
            <i class="fas" [ngClass]="copiado ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>{{ copiado ? 'Copiado' : 'Copiar' }}
          </button>
          <button type="button" class="primario" *ngIf="podeEnviarPelaMia" (click)="envieRascunho()" [disabled]="enviando || orientando || !rascunho.texto.trim()">
            <i class="fas" [ngClass]="enviando ? 'fa-spinner fa-spin' : 'fa-paper-plane'" aria-hidden="true"></i>{{ enviando ? 'Enviando…' : 'Enviar pela Mia' }}
          </button>
          <button type="button" (click)="monteRascunho()" [disabled]="enviando || orientando">
            <i class="fas" [ngClass]="orientando ? 'fa-spinner fa-spin' : 'fa-redo-alt'" aria-hidden="true"></i>Montar de novo
          </button>
          <button type="button" (click)="descarteRascunho()" [disabled]="enviando || orientando"><i class="fas fa-times" aria-hidden="true"></i>Descartar</button>
        </div>
        <small class="nota" *ngIf="podeEnviarPelaMia">Copiar: você cola e manda pelo WhatsApp ao lado. Enviar pela Mia: sai como fala dela e ela continua a conversa dali.</small>
        <small class="nota" *ngIf="!podeEnviarPelaMia">A Mia não está nesta conversa: copie e mande você pelo WhatsApp ao lado.</small>
      </div>
    </section>

    <p class="faixa faixa--erro" role="alert" *ngIf="erro">{{ erro }}</p>
    <p class="faixa faixa--ok" role="status" *ngIf="aviso"><i class="fas fa-check" aria-hidden="true"></i>{{ aviso }}</p>

    <ng-container *ngIf="dados.lead as lead">
      <h4 class="secao">Funil</h4>
      <div class="funil">
        <span class="selo selo--etapa selo--{{ lead.etapa | lowercase }}">{{ rotuloEtapa(lead.etapa) }}</span>
        <span class="selo selo--situacao selo--situacao-{{ sit.tom }}" *ngIf="situacaoConversa as sit" [title]="sit.dica">
          <i class="fas" [ngClass]="sit.icone" aria-hidden="true"></i>{{ sit.rotulo }}<ng-container *ngIf="sit.tempo"> · {{ sit.tempo }}</ng-container>
        </span>
        <span class="selo" *ngIf="dados.atendimento">{{ dados.atendimento.rotuloFase }}</span>
        <span class="selo selo--atencao" *ngIf="dados.atendimento?.encaminhamento">
          {{ dados.atendimento.encaminhamento.status === 'OPT_OUT' ? 'Pediu para parar' : 'Pediu a equipe' }}
        </span>
      </div>

      <dl class="dados" *ngIf="dados.atendimento?.ficha as ficha">
        <div *ngIf="ficha.segmento"><dt>Segmento</dt><dd>{{ ficha.segmento }}</dd></div>
        <div *ngIf="ficha.ferramentaAtual"><dt>Usa hoje</dt><dd>{{ ficha.ferramentaAtual }}</dd></div>
        <div *ngIf="ficha.problema"><dt>Problema</dt><dd>{{ ficha.problema }}</dd></div>
        <div *ngIf="ficha.objecao"><dt>Objeção</dt><dd>{{ ficha.objecao }}</dd></div>
        <div *ngIf="ficha.proximoPasso"><dt>Próximo passo</dt><dd>{{ ficha.proximoPasso }}</dd></div>
      </dl>

      <h4 class="secao">Oferta para este lead</h4>
      <app-oferta-lead-gestor [oferta]="ofertaDoLead" [urlSalvar]="'/gestor-ia/lead-contato/' + digitos + '/oferta'"
                              [urlSugerir]="'/gestor-ia/lead-contato/' + digitos + '/sugerir-oferta'" [podeSugerir]="!!dados.atendimento"
                              (salvo)="ofertaSalva($event)"></app-oferta-lead-gestor>

      <ng-container *ngIf="followup as f">
        <h4 class="secao">Follow-up automático</h4>
        <div class="followup">
          <p class="followup__texto"><i class="fas fa-redo-alt" aria-hidden="true"></i>{{ textoFollowup }}</p>
          <button type="button" *ngIf="f.ligadoNoNumero" (click)="mudeFollowup(!f.ligado)" [disabled]="mudandoFollowup">
            <i class="fas" [ngClass]="mudandoFollowup ? 'fa-spinner fa-spin' : (f.ligado ? 'fa-bell-slash' : 'fa-bell')" aria-hidden="true"></i>{{ f.ligado ? 'Desligar para este lead' : 'Ligar para este lead' }}
          </button>
        </div>
      </ng-container>

      <h4 class="secao">Dados do lead</h4>
      <dl class="dados">
        <div *ngIf="lead.nome"><dt>Nome</dt><dd>{{ lead.nome }}</dd></div>
        <div *ngIf="lead.empresa"><dt>Empresa</dt><dd>{{ lead.empresa }}</dd></div>
        <div *ngIf="lead.instagram"><dt>Instagram</dt><dd><a *ngIf="linkInstagram; else soTexto" [href]="linkInstagram" target="_blank" rel="noopener">{{ lead.instagram }}</a><ng-template #soTexto>{{ lead.instagram }}</ng-template></dd></div>
        <div *ngIf="lead.email"><dt>E-mail</dt><dd>{{ lead.email }}</dd></div>
        <div *ngIf="lead.temComputador !== null"><dt>Computador</dt><dd>{{ lead.temComputador ? 'Sim' : 'Não' }}</dd></div>
        <div><dt>Canal</dt><dd>{{ lead.canal || 'site' }}</dd></div>
        <div><dt>Origem</dt><dd>{{ rotuloOrigem(lead.origem) }}</dd></div>
        <div><dt>Registrado</dt><dd>{{ lead.ultimoFormularioEm | date:'dd/MM HH:mm' }}</dd></div>
        <div *ngIf="lead.primeiraMensagemEm"><dt>1ª mensagem</dt><dd>{{ lead.primeiraMensagemEm | date:'dd/MM HH:mm' }}</dd></div>
        <div *ngIf="lead.testeCriadoEm"><dt>Teste criado</dt><dd>{{ lead.testeCriadoEm | date:'dd/MM HH:mm' }}</dd></div>
        <div *ngIf="lead.testeAcessadoEm"><dt>Entrou no painel</dt><dd>{{ lead.testeAcessadoEm | date:'dd/MM HH:mm' }}</dd></div>
      </dl>

      <div class="perda" *ngIf="lead.etapa === 'PERDIDO' && !anotandoPerda">
        <p class="perda__motivo" *ngIf="lead.motivoPerda; else semMotivo"><i class="fas fa-comment-slash" aria-hidden="true"></i><span><strong>Motivo da perda:</strong> {{ lead.motivoPerda }}</span></p>
        <ng-template #semMotivo><p class="perda__motivo perda__motivo--vazio"><i class="fas fa-comment-slash" aria-hidden="true"></i><span>Sem motivo anotado.</span></p></ng-template>
        <button type="button" class="perda__editar" (click)="abraPerda()" [disabled]="movendo"><i class="fas fa-pen" aria-hidden="true"></i>{{ lead.motivoPerda ? 'Editar motivo' : 'Anotar motivo' }}</button>
      </div>

      <form class="perda perda--form" *ngIf="anotandoPerda" (ngSubmit)="confirmePerda()">
        <label for="motivo-perda">{{ lead.etapa === 'PERDIDO' ? 'Motivo da perda' : 'Por que perdemos este lead?' }}</label>
        <textarea id="motivo-perda" name="motivoPerda" rows="3" maxlength="300" [(ngModel)]="motivoPerda" autofocus
                  placeholder="Ex.: achou caro, já usa outro sistema, parou de responder…"></textarea>
        <small class="perda__sugestao" *ngIf="motivoSugerido"><i class="fas fa-robot" aria-hidden="true"></i>Sugerido pela objeção que a Mia registrou na ficha. Edite se for outro.</small>
        <div class="perda__botoes">
          <button type="submit" class="perigo" [disabled]="movendo"><i class="fas" [ngClass]="movendo ? 'fa-spinner fa-spin' : 'fa-times'" aria-hidden="true"></i>{{ lead.etapa === 'PERDIDO' ? 'Salvar motivo' : 'Marcar como perdido' }}</button>
          <button type="button" (click)="cancelePerda()" [disabled]="movendo">Cancelar</button>
        </div>
      </form>

      <div class="acoes">
        <button type="button" (click)="mova('CLIENTE')" [disabled]="movendo || lead.etapa === 'CLIENTE'"><i class="fas fa-trophy" aria-hidden="true"></i>Cliente</button>
        <button type="button" class="perigo" (click)="abraPerda()" [disabled]="movendo || anotandoPerda || lead.etapa === 'PERDIDO'"><i class="fas fa-times" aria-hidden="true"></i>Perdido</button>
        <a class="botao botao--link" [href]="linkKanban" target="_blank" rel="noopener">Ver no kanban<i class="fas fa-external-link-alt" aria-hidden="true"></i></a>
      </div>
      <div class="acoes acoes--futuras">
        <button type="button" disabled title="Disponível na próxima etapa"><i class="fas fa-hand-paper" aria-hidden="true"></i>Assumir</button>
        <button type="button" disabled title="Disponível na próxima etapa"><i class="fas fa-robot" aria-hidden="true"></i>Devolver para a Mia</button>
        <small>Assumir e devolver chegam na próxima etapa.</small>
      </div>
    </ng-container>
  </ng-container>
</section>
